import type {
  AnyFieldApi,
  FormApi,
  ReactFormExtendedApi,
} from '@tanstack/react-form';
import type { InputAreaProps } from '@tuic/web-compositions/shared/InputArea';
import type { InputFieldProps } from '@tuic/web-compositions/shared/InputField';
import type { SelectFieldProps } from '@tuic/web-compositions/shared/SelectField';
import type { ChangeEvent } from 'react';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type GenericSimpleFormApi<D> = FormApi<D, any, any, any, any, any, any, any, any, any, any, any>;

export type SimpleFormApi<D> = GenericSimpleFormApi<D> &
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ReactFormExtendedApi<D, any, any, any, any, any, any, any, any, any, any, any>;

export function formInputField(
  field: AnyFieldApi,
): Pick<InputFieldProps, 'onBlur' | 'onChange' | 'value' | 'name' | 'error'> {
  return {
    onBlur: field.handleBlur,
    onChange: e => field.handleChange(e.target.value),
    value: field.state.value as HTMLInputElement['value'],
    name: field.name,
    error: field.state.meta.errors.map(e => e.message).join(','),
  };
}

export function formInputArea(
  field: AnyFieldApi,
): Pick<InputAreaProps, 'onBlur' | 'onChange' | 'value' | 'name' | 'error'> {
  return {
    onBlur: field.handleBlur,
    onChange: e => field.handleChange(e.target.value),
    value: field.state.value as HTMLTextAreaElement['value'],
    name: field.name,
    error: field.state.meta.errors.map(e => e.message).join(','),
  };
}

export function formSelectField(
  field: AnyFieldApi,
): Pick<
  SelectFieldProps,
  'onChange' | 'defaultValue' | 'value' | 'name' | 'error'
> {
  return {
    onChange: (e: ChangeEvent<HTMLSelectElement>) =>
      field.handleChange(e.target.value),
    defaultValue: field.state.value,
    value: field.state.value as HTMLInputElement['value'],
    name: field.name,
    error: field.state.meta.errors.map(e => e.message).join(','),
  };
}

export function formCheckboxField(field: AnyFieldApi) {
  return {
    checked: field.state.value as boolean,
    onChange: (e: ChangeEvent<HTMLInputElement>) =>
      field.handleChange(e.target.checked),
    error: field.state.meta.errors.map(e => e.message).join(','),
  };
}
